import React from 'react';
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { DEFAULT_GRADIENT, DEFAULT_THEME_COLOR } from "../../constants/theme";

const RANK_META = [
  { label: '🏆', border: '#FFD700', glow: 'rgba(255,215,0,0.35)', bg: 'linear-gradient(135deg, rgba(255,215,0,0.10) 0%, rgba(13,27,42,0.95) 100%)' },
  { label: '🥈', border: '#C0C0C0', glow: 'rgba(192,192,192,0.3)',  bg: 'linear-gradient(135deg, rgba(192,192,192,0.08) 0%, rgba(13,27,42,0.95) 100%)' },
  { label: '🥉', border: '#CD7F32', glow: 'rgba(205,127,50,0.3)',   bg: 'linear-gradient(135deg, rgba(205,127,50,0.08) 0%, rgba(13,27,42,0.95) 100%)' },
];

const LeaderboardRow = ({ item, idx }) => {
  const navigate = useNavigate();
  const isPodium = idx < 3;
  const meta = RANK_META[idx];

  return (
    <Box
      onClick={() => navigate(`/@${item.username}`)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1.5, sm: 2 },
        px: { xs: 1.5, sm: 2.5 },
        py: { xs: 1.5, sm: isPodium ? 2 : 1.5 },
        mb: 1,
        borderRadius: 2,
        cursor: 'pointer',
        background: isPodium
          ? meta.bg
          : 'linear-gradient(135deg, rgba(13,27,42,0.8) 0%, rgba(9,20,32,0.8) 100%)',
        border: isPodium
          ? `1px solid ${meta.border}44`
          : '1px solid rgba(255,255,255,0.06)',
        boxShadow: isPodium ? `0 2px 16px ${meta.glow}` : 'none',
        transition: 'all 0.18s',
        '&:hover': {
          background: 'linear-gradient(135deg, rgba(54,201,162,0.10) 0%, rgba(79,172,254,0.10) 100%)',
          border: `1px solid rgba(54,201,162,0.3)`,
          transform: 'translateX(3px)',
        },
      }}
    >
      {/* Rank */}
      <Box
        sx={{
          minWidth: { xs: 36, sm: 44 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        {isPodium ? (
          <Typography sx={{ fontSize: { xs: 22, sm: 28 }, lineHeight: 1 }}>
            {meta.label}
          </Typography>
        ) : (
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: { xs: 14, sm: 16 },
              color: idx < 10 ? DEFAULT_THEME_COLOR : 'rgba(255,255,255,0.35)',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {idx + 1}
          </Typography>
        )}
      </Box>

      {/* Avatar */}
      <Avatar
        alt={item.username}
        src={item.imageUrl || './icon-48x48.png'}
        sx={{
          width: { xs: 40, sm: isPodium ? 52 : 44 },
          height: { xs: 40, sm: isPodium ? 52 : 44 },
          flexShrink: 0,
          border: isPodium ? `2px solid ${meta.border}` : '2px solid rgba(255,255,255,0.1)',
          boxShadow: isPodium ? `0 0 12px ${meta.glow}` : 'none',
        }}
      />

      {/* Name + handle */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          noWrap
          sx={{
            fontWeight: 700,
            fontSize: { xs: 14, sm: 15 },
            color: 'white',
            lineHeight: 1.2,
          }}
        >
          {item.username}
        </Typography>
        <Typography
          noWrap
          sx={{
            fontSize: 12,
            color: 'rgba(255,255,255,0.4)',
            mt: 0.3,
          }}
        >
          @{item.username}
        </Typography>
      </Box>

      {/* Points badge */}
      <Box
        sx={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          background: isPodium
            ? `linear-gradient(135deg, ${meta.border}22, ${meta.border}11)`
            : 'rgba(54,201,162,0.1)',
          border: isPodium
            ? `1px solid ${meta.border}55`
            : '1px solid rgba(54,201,162,0.25)',
          borderRadius: 2,
          px: { xs: 1, sm: 1.5 },
          py: 0.5,
        }}
      >
        <Avatar
          src="./icon-48x48.png"
          sx={{ width: 14, height: 14 }}
        />
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: { xs: 12, sm: 13 },
            color: isPodium ? meta.border : DEFAULT_THEME_COLOR,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {item.points}F
        </Typography>
      </Box>
    </Box>
  );
};

export default LeaderboardRow;
